import { Identifier } from "../../id";
export class MenuArragmentId extends Identifier {
    constructor(id) {
        super("MenuArragmentId", id);
    }
}
